document.querySelectorAll(".popup-btn").forEach((btn) => {
  btn.addEventListener("click", function () {
    const target = document.querySelector(this.dataset.target);
    if (target) {
      target.style.display = "flex";
      document.body.classList.add("popup-open"); // Add class to body
    }
  });
});

document.querySelectorAll(".close-popup").forEach((btn) => {
  btn.addEventListener("click", function () {
    const popup = this.closest(".popup-overlay");
    popup.style.display = "none";
    document.body.classList.remove("popup-open"); // Remove class from body
  });
});

// Optional: close on outside click
document.querySelectorAll(".popup-overlay").forEach((popup) => {
  popup.addEventListener("click", function (e) {
    if (e.target === popup) {
      popup.style.display = "none";
      document.body.classList.remove("popup-open"); // Remove class from body
    }
  });
});
